import React from 'react';

import { IFlexProps } from './types';

function Flex({
  direction = 'row',
  justifyContent = 'flex-start',
  alignItems = 'flex-start',
  className,
  children,
  gap = 0,
  ...styles
}: IFlexProps) {
  const flexContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: direction,
    justifyContent,
    alignItems,
    gap,
    ...styles,
  };

  return <div className={className} style={{ ...flexContainerStyle, ...styles }}>{children}</div>;
}

export default Flex;
